import type { SVGProps } from 'react';
const DawnFlagTG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-TG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-TG_svg__a)">
      <path fill="#FFD44D" d="M0 0h22v16H0z" />
      <path
        fill="#159A74"
        fillRule="evenodd"
        d="M9.429 0H22v3.2H9.429zm0 6.4H22v3.2H9.429zM22 12.8H0V16h22z"
        clipRule="evenodd"
      />
      <path fill="#ED1F45" d="M0 0h9.429v9.6H0z" />
      <path
        fill="#fff"
        fillRule="evenodd"
        d="M4.714 6.048 2.867 7.39l.681-2.203L1.725 3.81l2.269-.02.72-2.19.72 2.19 2.27.02L5.88 5.186l.681 2.203z"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagTG;
